export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAAXNSR0IArs4c6QAAABNJREFUGFdj/P///38GLIBxICUA8xQX7zAExF8AAAAASUVORK5CYII="